module.exports = __webpack_public_path__ + "static/media/search.ed806bda.svg";